import { YearDropDown } from '@apply/components/';
import { usePropertyYearBuilt } from '../../../queries/PropertyFields/NonRentalCoreFields';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';

export interface YearBuiltProps {
    propertyGuid: string;
    readOnly?: boolean;
    required?: boolean;
    isReview?: boolean;
}

export const YearBuilt: React.FC<YearBuiltProps> = ({ propertyGuid, readOnly = false, required = false, isReview = false }) => {
    const label = 'Year Built';
    const [year, set_year] = usePropertyYearBuilt(propertyGuid);

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={year}
                />
            ) : (
                <>
                    <YearDropDown
                        id={'yearBuiltDropDown'}
                        value={year}
                        onChange={(value) => {
                            if (value === null || value === undefined || value === '') {
                                set_year(undefined);
                            } else {
                                set_year(parseInt(value));
                            }
                        }}
                        label={label}
                        yearStart={1850}
                        required={required}
                        readOnly={readOnly}
                    />
                </>
            )}
        </>
    );
};
